export default "__VITE_ASSET__C8nUq49c__"